/** Tokens do layout Stitch (cadastro público) — espelha `code.html` do export. */
export const STITCH = {
  bg: '#f7f9fc',
  primary: '#34005f',
  onPrimary: '#ffffff',
  surfaceLowest: '#ffffff',
  surfaceLow: '#f2f4f7',
  outlineVariant: '#cdc3d2',
  surfaceContainerHigh: '#e6e8eb',
  onSurface: '#191c1e',
  onSurfaceVariant: '#4b4450',
  primaryFixed: '#efdbff',
  onPrimaryFixed: '#2b0052',
  shadowCard: '0px 4px 12px rgba(75, 30, 120, 0.05)',
  /** Largura do card do formulário (Stitch original usava 800px; reduzido para leitura mais confortável). */
  maxContentWidth: 640,
} as const;
